const selectExtensions = (state) => state.extensions;
export default selectExtensions;
